/**
 * Twitter sharing utilities
 */

/**
 * Convert canvas to blob for uploading
 */
export async function canvasToBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to convert canvas to blob'));
        }
      },
      'image/png',
      1.0
    );
  });
}

/**
 * Download image from canvas
 */
export function downloadCanvasImage(canvas: HTMLCanvasElement, filename: string = 'lottery-win.png') {
  canvas.toBlob((blob) => {
    if (!blob) return;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 'image/png');
}

/**
 * Share to Twitter with text
 * Note: Twitter doesn't support direct image upload from web share
 * We provide the text and the user can attach their downloaded image
 */
export function shareToTwitter(text: string, url?: string) {
  const encodedText = encodeURIComponent(text);
  const twitterUrl = url
    ? `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodeURIComponent(url)}`
    : `https://twitter.com/intent/tweet?text=${encodedText}`;

  window.open(twitterUrl, '_blank', 'width=550,height=420');
}

/**
 * Copy image to clipboard (for modern browsers)
 */
export async function copyImageToClipboard(canvas: HTMLCanvasElement): Promise<boolean> {
  try {
    const blob = await canvasToBlob(canvas);

    if (navigator.clipboard && ClipboardItem) {
      const item = new ClipboardItem({ 'image/png': blob });
      await navigator.clipboard.write([item]);
      return true;
    }

    return false;
  } catch (error) {
    console.error('Failed to copy image to clipboard:', error);
    return false;
  }
}

/**
 * Open Twitter share with text and option to download image
 */
export function shareRewardToTwitter(
  text: string,
  canvas: HTMLCanvasElement,
  options?: {
    downloadImage?: boolean;
    filename?: string;
  }
) {
  // Download image if requested
  if (options?.downloadImage) {
    downloadCanvasImage(canvas, options.filename);
  }

  // Open Twitter share
  shareToTwitter(text);
}
